import Cookies from 'js-cookie';
const matchVisitorIdInCookie = (cookieValue) => cookieValue.match(/v_id:[\w-]*/);
const getVisitorIdFromTealium = () => {
    var _a, _b;
    const visitorIdPropertyName = 'tealium_visitor_id';
    return (_b = (_a = window.utag) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b[visitorIdPropertyName];
};
const getVisitorIdFromCookie = () => {
    const cookieName = 'utag_main';
    const cookieValue = Cookies.get(cookieName);
    if (cookieValue) {
        const matchingResult = matchVisitorIdInCookie(cookieValue);
        return matchingResult === null || matchingResult === void 0 ? void 0 : matchingResult[0].split(':')[1];
    }
    return undefined;
};
const generateRandomVisitorId = () => `visitor-${Date.now()}-${Math.ceil(Math.random() * 10)}`;
export const getVisitorId = () => getVisitorIdFromTealium() || getVisitorIdFromCookie() || generateRandomVisitorId();
//# sourceMappingURL=visitorId.js.map